import { useTranslation } from 'react-i18next';
import '../../../styles/pages/tara/taraUI/taraChatbotConnection.scss';
import { slackOriginalSVG, whatsappSVG } from '../../../lib/allCustomSVGs';
import CustomSVGs from '../../../ui/customSVGs/CustomSVGs';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { RootState } from '../../../store/store';

const TaraChatbotConnection = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const userRole: 'seller' | 'agency' =
    useSelector((state: RootState) => state.user?.profile?.role) === 'agency'
      ? 'agency'
      : 'seller';
  return (
    <div className='taraChatbotConnection'>
      <span className='taraChatbotConnection__text'>
        {t('YouCanChatWithTaraIn')}
      </span>
      <div className='taraChatbotConnection__icons'>
        <div
          title='Connect to Slack'
          className='taraChatbotConnection__icons--icon'
          onClick={(e) => {
            e.preventDefault();
            window.open('https://slackapi.adup.io/slack/install', '_blank');
          }}
        >
          <CustomSVGs svg={slackOriginalSVG} />
        </div>
        {userRole !== 'agency' && (
          <div
            title='Connect to WhatsApp'
            className='taraChatbotConnection__icons--icon'
            onClick={() => {
              navigate('/settings/communication');
            }}
          >
            <CustomSVGs fillColor='#16a34a' svg={whatsappSVG} />
          </div>
        )}
      </div>
    </div>
  );
};

export default TaraChatbotConnection;
